// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import resolutionVersionEntity from './entities/resolution-version.json';
import resolutionVersionMenu from '../pages/resolution-version/menu.json';
import resolutionVersionFullForm from '../pages/resolution-version/forms/full.json';
import resolutionVersionContextForm from '../pages/resolution-version/forms/context.json';
import resolutionVersionMiniForm from '../pages/resolution-version/forms/mini.json';
import resolutionVersionLookupForm from '../pages/resolution-version/forms/lookup.json';
import resolutionVersionTableView from '../pages/resolution-version/views/table.json';
import resolutionVersionCardsView from '../pages/resolution-version/views/cards.json';
import resolutionVersionCalendarView from '../pages/resolution-version/views/calendar.json';
import resolutionVersionDashboardView from '../pages/resolution-version/views/dashboard.json';

/** Тип запису «Редакція постанови» зі сторінками пакета: меню, форми та подання з pages/resolution-version/. */
export const resolutionVersionDefinition: IRecordTypeDefinition = {
  ...resolutionVersionEntity,
  views: assembleViewSet({
      table: resolutionVersionTableView,
      cards: resolutionVersionCardsView,
      calendar: resolutionVersionCalendarView,
      dashboard: resolutionVersionDashboardView,
  }),
  form: resolutionVersionFullForm,
  forms: { full: resolutionVersionFullForm, context: resolutionVersionContextForm, mini: resolutionVersionMiniForm, lookup: resolutionVersionLookupForm },
  menu: resolutionVersionMenu,
} as IRecordTypeDefinition;
